// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Ju1fZ","red":"Button_red__20Kqc","buttonOutline":"Button_buttonOutline__8exjA"};